import { render, staticRenderFns } from "./InventoryDialog.vue?vue&type=template&id=5af96018&"
import script from "./InventoryDialog.vue?vue&type=script&lang=js&"
export * from "./InventoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports